import {
    useMap,
} from '@vis.gl/react-google-maps';
import { useEffect, useState } from "react";
import { Polygon } from "../elements/Polygon";
import MapPropertiesService from '../../services/MapPropertiesService';
import MapService, { IMapService } from '../../services/MapService';
import { useSetMapTitle } from '../../hooks/useMapStore';

interface SegmentFeaturePolygonProps {
    source: any,
    mouseOverId?: number,
    focusId?: number,
    onMouseOver?: (e: number) => void,
    onMouseOut?: () => void,
    onClick?: (e: number) => void
}
export const SegmentFeaturePolygon = ({
    source,
    mouseOverId,
    focusId,
    onMouseOver,
    onMouseOut,
    onClick
}: SegmentFeaturePolygonProps) => {

    const map = useMap();

    const setMapTitle = useSetMapTitle();

    const mapProperties = MapPropertiesService.properties;
    const mapService: IMapService = new MapService();
    
    const [isFocused, setIsFocused] = useState(false);

    const [fillColor, setFillColor] = useState(mapProperties.DefaultFillColor);
    const [strokeColor, setStrokeColor] = useState(mapProperties.DefaultStrokeColor);
    const [strokeWeight, setStrokeWeight] = useState(2);

    useEffect(() => {
        if (source.properties.segmentId === mouseOverId) {
            handleOnMouseOver();
        } else {
            handleOnMouseOut();
        }
    }, [mouseOverId]);

    useEffect(() => {
        if (!map) return;
        if (source.properties.segmentId === focusId) {
            const bounds = mapService.getFeaturePathBounds(source);
            map.fitBounds(bounds);
            setIsFocused(true);
            onFocused();
        } else {
            setIsFocused(false);
            handleOnMouseOut();
        }
    }, [focusId]);

    return (
        <Polygon
            paths={source.paths}
            fillColor={fillColor}
            fillOpacity={mapProperties.DefaultOpacity}
            strokeColor={strokeColor}
            strokeWeight={strokeWeight}
            zIndex={1}
            onMouseOver={() => {
                handleOnMouseOver();
                setMapTitle(source.properties.segmentName);

                if (!onMouseOver) return;
                onMouseOver(source.properties.segmentId);
            }}
            onMouseOut={() => {
                handleOnMouseOut(isFocused);
                setMapTitle("");
                if (!onMouseOut) return;
                onMouseOut();
            }}
            onClick={handleOnClick}
        />
    );

    function onFocused() {
        setStrokeColor(mapProperties.SelectedStrokeColor);
        setFillColor(mapProperties.SelectedFillColor);
        setStrokeWeight(4);
    }

    function handleOnMouseOver() {
        setStrokeColor(mapProperties.MouseOverStrokeColor);
        setFillColor(mapProperties.MouseOverStrokeColor);
        setStrokeWeight(4);
    }

    function handleOnMouseOut(focused = false) {
        setStrokeColor(focused ? mapProperties.SelectedStrokeColor : mapProperties.DefaultStrokeColor);
        setFillColor(focused ? mapProperties.SelectedFillColor : mapProperties.DefaultFillColor);
        setStrokeWeight(focused ? 4 : 2);
    }

    function handleOnClick() {
        if (!onClick) return;
        onClick(source.properties.segmentId);
    }
}
